import {useContext} from "react";
import {AppContext} from "../../App";
import categories from "../../data/categories.json";
import {getCityName} from "../Property/PropertyHelper";

function Breadcrumb({className = "", props, title}) {
    const {citiesLoading} = useContext(AppContext);

    const indexMapping = [
        'home',
        'actionType',
        'type',
        'city',
        'ref',
        'ref'
    ];

    const pathName = window.location.pathname.split("/");
    if (window.location.pathname.endsWith("/")) {
        pathName.pop();
    }
    let currentUrl = "";
    let breadcrumb = pathName;

    function getText(item, index) {
        switch (indexMapping[index]) {
            case "home":
                return "Accueil";
            case "actionType":
                return (props.actionType ? (props.actionType === "Acheter" ? "Vente" : "Location") : title);
            case "type":
                return item === "promotions" ?
                    item.charAt(0).toUpperCase() + item.slice(1) :
                    categories.find((category) => category.name === props.types[0]).value;
            case "city":
                return getCityName(item.split("-")[0], item.split("-")[item.split("-").length - 1], citiesLoading);
            case "ref":
                return item.toUpperCase();
            default:
                break;
        }
    }

    return (
        <div className={"flex overflow-x-scroll md:overflow-x-hidden " + className} aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                {breadcrumb.map((item, index) => {
                    currentUrl += item + "/";
                    const last = index === breadcrumb.length - 1;
                    const textColor = !last ? "text-primary hover:text-primary-light" : "text-gray-500";
                    const icon = index === 0 ?
                        <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                             fill="currentColor" viewBox="0 0 20 20">
                            <path
                                d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
                        </svg>
                        :
                        <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true"
                             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                  strokeWidth="2" d="m1 9 4-4-4-4"/>
                        </svg>;

                    return <li key={index} className="inline-flex items-center min-w-fit">
                        <span
                            className={"inline-flex items-center text-sm font-medium " + textColor}>
                            {icon}
                            {last ? getText(item, index) : <a href={currentUrl}>{getText(item, index)}</a>}
                        </span>
                    </li>
                })}
            </ol>
        </div>
    );
}

export default Breadcrumb;